import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorBorder, colorBackground, colorHover } from '@/utils/palette';
import { left } from '@/utils/directions';
import SidebarLink, {
    //  SidebarNavLink,
    SidebarLinkTitle,
} from './SidebarLink';
// import SidebarCategory from './SidebarCategory';

const SidebarContent = ({
    onClick,
    // , changeToLight, changeToDark,
    collapse,
}: any) => (
    <SidebarContentWrap collapse={collapse}>
        <SidebarBlock collapse={collapse}>
            {/* <SidebarCategory title="Layout" icon="layers" collapse={collapse}>
                <SidebarNavLink as="button" type="button" onClick={changeToLight}>
                    <SidebarLinkTitle>Light Theme</SidebarLinkTitle>
                </SidebarNavLink>
                <SidebarNavLink as="button" type="button" onClick={changeToDark}>
                    <SidebarLinkTitle>Dark Theme</SidebarLinkTitle>
                </SidebarNavLink>
            </SidebarCategory> */}
            <SidebarLink title="Users" icon="list" route="/users" onClick={onClick} />
            <SidebarLink title="Telegram Bot Stats" icon="chart-bars" route="/telegram-bot-stats" onClick={onClick} />
            <SidebarLink title="Categories" icon="list" route="/categories" onClick={onClick} />
            <SidebarLink title="Contents" icon="film-play" route="/contents" onClick={onClick} />
            <SidebarLink title="Courses" icon="book" route="/courses" onClick={onClick} />
            <SidebarLink title="Blog" icon="pencil" route="/blog" onClick={onClick} />
            <SidebarLink title="Products" icon="store" route="/products" onClick={onClick} />
            <SidebarLink title="Orders" icon="cart" route="/orders" onClick={onClick} />
            <SidebarLink title="Cohorts" icon="users" route="/cohorts" onClick={onClick} />
            {/* Course clients + their Harmony Board shipment. A projection over
                users/orders/cohorts — not a separate client record. */}
            <SidebarLink title="Course CRM" icon="users" route="/course-crm" onClick={onClick} />
            <SidebarLink title="Events" icon="calendar-full" route="/events" onClick={onClick} />
            <SidebarLink title="Live Sessions" icon="users" route="/live-sessions" onClick={onClick} />
            {/* Practice rooms — NOT live sessions. No host, no media, no call. */}
            <SidebarLink title="Meditation Rooms" icon="apartment" route="/meditation-rooms" onClick={onClick} />
            <SidebarLink title="Event Registrations" icon="license" route="/event-registrations" onClick={onClick} />
            <SidebarLink title="Content Reports" icon="flag" route="/content-reports" onClick={onClick} />
            <SidebarLink title="Course 33 Videos" icon="film-play" route="/course-33-videos" onClick={onClick} />
            <SidebarLink title="Course 33 Day-0 Videos" icon="film-play" route="/course-33-day0-videos" onClick={onClick} />
            <SidebarLink title="Course 33 Day Media" icon="film-play" route="/course-33-day-media" onClick={onClick} />
            <SidebarLink title="Astro Tips" icon="star" route="/astro-tips" onClick={onClick} />
            <SidebarLink title="Schedules" icon="calendar-full" route="/schedules" onClick={onClick} />
            <SidebarLink title="Settings" icon="cog" route="/settings" onClick={onClick} />
            <SidebarLink title="Referrals" icon="gift" route="/referrals" onClick={onClick} />
            <SidebarLink title="App Dashboard" icon="smartphone" route="/app_dashboard" onClick={onClick} />
            <SidebarLink title="Booking Dashboard" icon="apartment" route="/booking_dashboard" onClick={onClick} />
            <SidebarLink title="Finance Dashboard" icon="rocket" route="/finance_dashboard" onClick={onClick} newLink />
        </SidebarBlock>
    </SidebarContentWrap>
);

SidebarContent.propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    collapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
    collapse: false,
    onClick: () => {},
};

export default SidebarContent;

const SidebarContentWrap = styled.div<any>`
    height: 100%;
    overflow: auto;
    padding-top: 0;

    & > div:last-child {
        width: 4px !important;

        div {
            transition: height 0.3s;
            opacity: 0.52;
        }
    }

    @media screen and (min-width: 576px) {
        padding-top: 15px;

        ${(props: any) =>
            props.collapse &&
            `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
    }
`;

const SidebarBlock = styled.ul<any>`
    padding: 15px 0;
    border-bottom: 1px solid ${colorBorder};
    list-style-type: none;

    &:last-child {
        border: none;
    }

    @media screen and (min-width: 576px) {
        ${(props: any) =>
            props.collapse &&
            `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};
        
        span:last-of-type {
          opacity: 0;
          transition: 0.3s;
        }
  
        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
        }
  
        &:hover {
          background: ${colorHover(props)};
        }
      }
      
      & > li:hover > a,
      & > li:hover > button {
        width: 275px;
        
        span {
          opacity: 1;
        }
      }
    `}
    }
`;
